const normalizeBackendUrl = (value?: string) => {
  if (!value) return null
  return value.replace(/\/+$/, '')
}

const toWebSocketUrl = (value: string) => {
  if (value.startsWith('https://')) return `wss://${value.slice('https://'.length)}`
  if (value.startsWith('http://')) return `ws://${value.slice('http://'.length)}`
  return value
}

export const getBackendUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_BACKEND_URL as string | undefined)
  return envUrl ?? 'http://localhost:8080'
}

const getGatewayBackedServiceUrl = (value?: string) => {
  const serviceUrl = normalizeBackendUrl(value)
  if (serviceUrl) return serviceUrl
  return getBackendUrl()
}

export const getAuthUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_AUTH_URL as string | undefined)
  return envUrl ?? 'http://localhost:3010'
}

export const getBackendWsUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_BACKEND_URL as string | undefined)
  if (envUrl) return toWebSocketUrl(envUrl)
  if (typeof window !== 'undefined') {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    return `${proto}//${window.location.host}`
  }
  return 'ws://localhost:8080'
}

export const getVoiceAgentUrl = () => {
  const agentUrl = normalizeBackendUrl(import.meta.env.VITE_AGENT_SERVICE_URL as string | undefined)
  if (agentUrl) return toWebSocketUrl(agentUrl)

  const envUrl = normalizeBackendUrl(import.meta.env.VITE_VOICE_AGENT_URL as string | undefined)
  return envUrl ?? 'ws://127.0.0.1:8000'
}

export const getChatAgentUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_CHAT_AGENT_URL as string | undefined)
  return envUrl ? toWebSocketUrl(envUrl) : getAgentServiceWsUrl()
}

export const getEnrichmentUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_ENRICHMENT_URL as string | undefined)
  return envUrl ?? 'http://localhost:8001'
}

export const getCrmServiceUrl = (): string => {
  return normalizeBackendUrl(import.meta.env.VITE_CRM_SERVICE_URL)
    ?? 'http://localhost:3009'
}

export const getUserServiceUrl = () =>
  normalizeBackendUrl(import.meta.env.VITE_USER_SERVICE_URL as string | undefined)
    ?? 'http://localhost:3010'

export const getChatServiceUrl = () =>
  normalizeBackendUrl(import.meta.env.VITE_CHAT_SERVICE_URL as string | undefined)
    ?? 'http://localhost:8002'

export const getMemoryServiceUrl = () =>
  getGatewayBackedServiceUrl(import.meta.env.VITE_MEMORY_SERVICE_URL as string | undefined)

export const getCatalogServiceUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_AGENT_SERVICE_URL as string | undefined)
  return envUrl ?? 'http://localhost:8000'
}

export const getAgentServiceUrl = () => {
  const envUrl = normalizeBackendUrl(import.meta.env.VITE_AGENT_SERVICE_URL as string | undefined)
  return envUrl ?? 'http://localhost:8000'
}

export const getAgentServiceWsUrl = () => {
  return toWebSocketUrl(getAgentServiceUrl())
}
